import React, { Component } from "react";
import styles from "./Actions.module.scss";
import List from "../../1_atoms/List/List";
import actions from "./Actions.json";
import { t } from "../../../helpers/translate.helper";

class Actions extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (document.referrer && document.referrer !== document.location.href && !/[&?]noIntro/i.test(document.location.search)) {
      setTimeout( () => {
      this.handleSelectInformation(actions.information[0], 0);
      },1000)
    }
  }

  componentDidUpdate(newProps) {
    if (newProps.language !== this.props.language) {
      const entry = this.state.selectedList >= 0
        && actions[this.state.selectedList === 0 ? 'information' : 'entertainment'][this.state.selectedIndex];
      if (entry) {
        this.props.playScript(entry.script || t(entry.script_translate));
        this.deselect();
      }
      else {
        this.props.playScript(null);
      }
    }
  }

  deselect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    this.timeout = setTimeout(
      () => this.setState({ selectedIndex: -1, selectedList: -1 }),
      10000
    );
  }

  handleSelectInformation(entry, index) {
    this.props.playScript(entry.script || t(entry.script_translate));
    this.setState({ selectedIndex: index, selectedList: 0 });
    this.deselect();
  }

  handleSelectEntertainment(entry, index) {
    this.props.playScript(entry.script || t(entry.script_translate));
    this.setState({ selectedIndex: index, selectedList: 1 });
    this.deselect();
  }

  render() {
    const { selectedIndex, selectedList } = this.state;
    return (
      <div className={styles.host}>
        <div className={styles.panel}>
          <List
            label={t('information')}
            entries={actions.information}
            handleSelect={this.handleSelectInformation.bind(this)}
            selectedIndex={selectedList === 0 ? selectedIndex : -1} />
        </div>
        <div className={styles.panel}>
          <List
            label={t('entertainment')}
            entries={actions.entertainment}
            handleSelect={this.handleSelectEntertainment.bind(this)}
            selectedIndex={selectedList === 1 ? selectedIndex : -1} />
        </div>
      </div>
    );
  }
}

export default Actions;
